import $ from "jquery";
import Siema from "siema";
$(document).ready(function () {
    $(".siema").each(function (k, v) {
        var nav = null;
        var mySiema;
        if ($("[data-siema-nav='" + $(v).data("controls") + "']").length) {
            nav = $("[data-siema-nav='" + $(v).data("controls") + "']");
        }
        var options = {
            selector: v,
            perPage: {
                600: 1,
                768: 2.2,
                1024: 2.2
            },
            onChange: function () {
                if (nav != null) {
                    $(nav).children(".current").removeClass("current");
                    $(nav).find(".siema-bullet:eq(" + mySiema.currentSlide + ")").addClass("current");
                }
            }
        };
        if ($(v).attr("data-unique") !== void 0) {
            options.perPage = { 768: 1, 1024: 1 };
        }
        mySiema = new Siema(options);
        var prev = $('[data-siema-prev="' + $(v).data("controls") + '"]');
        var next = $('[data-siema-next="' + $(v).data("controls") + '"]');
        prev.on('click', function () { return mySiema.prev(); });
        next.on('click', function () { return mySiema.next(); });
        if (nav != null) {
            $(v).children().children().each(function (k, v) {
                var bullet = document.createElement("a");
                nav.append(bullet);
                $(bullet).addClass("siema-bullet");
                if (k == 0) {
                    $(bullet).addClass("current");
                }
                $(bullet).on("click", function (e) {
                    e.preventDefault();
                    mySiema.goTo(k, function () {
                        $(nav).find(".current").removeClass("current");
                        $(bullet).addClass("current");
                    });
                });
            });
        }
    });
});
